import { render } from "./Pokemon.vue?vue&type=template&id=451d46b4&scoped=true"
import script from "./Pokemon.vue?vue&type=script&lang=js"
export * from "./Pokemon.vue?vue&type=script&lang=js"

import "./Pokemon.vue?vue&type=style&index=0&id=451d46b4&scoped=true&lang=css"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451d46b4"]])

export default __exports__